import { useNotificationStore } from "@/stores/notificationStore";
import * as Sentry from "@sentry/vue";

type KnownError = { message: string; color: string };

function isKnownError(error: unknown): error is KnownError {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as Record<string, unknown>).message === "string" &&
    "color" in error &&
    typeof (error as Record<string, unknown>).color === "string"
  );
}

export const notifySuccess = (message: string | unknown, color?: string) => {
  const notificationStore = useNotificationStore();
  notificationStore.notifySuccess(message as string, color);
};

export const notifyWarning = (message: string | unknown) => {
  const notificationStore = useNotificationStore();
  notificationStore.notifyWarning(message as string);
};

export const notifyError = (error: string | unknown | KnownError) => {
  const notificationStore = useNotificationStore();
  let myMessage = "Erreur inconnue";
  let myColor = "error";

  if (typeof error === "string") {
    myMessage = error;
  } else if (isKnownError(error)) {
    myMessage = error.message;
    myColor = error.color;
  } else if (error instanceof Error) {
    myMessage = error.message;
  }
  Sentry.captureMessage(myMessage, { level: "error" });
  notificationStore.notifyError(myMessage, myColor);
};

export const notifyInformation = (message: string | unknown) => {
  const notificationStore = useNotificationStore();
  notificationStore.notifyInformation(message as string);
};

export default {
  notifySuccess,
  notifyWarning,
  notifyError,
  notifyInformation,
};
